module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marguerite Henry\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Marguerite Henry (1902–1997) was the beloved author of such classic horse stories as "), _c('I', [_vm._v("King of the Wind")]), _vm._v(", "), _c('I', [_vm._v("Misty of Chincoteague")]), _vm._v(", and "), _c('I', [_vm._v("Stormy, Misty’s Foal")]), _vm._v(", and her work has won several Newbery Awards and Honors. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BQocvK/tc-custom/9781442488038.jpg?1713387613881",
      "alt": "This image is the cover for the book Brighty of the Grand Canyon, Marguerite Henry Horseshoe Library"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Brighty of the Grand Canyon, Marguerite Henry Horseshoe Library\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A determined little burro earns the loyalty and affection of everyone he encounters in this classic story from Newbery Award–winning author Marguerite Henry.")]), _c('br'), _c('br'), _vm._v("Long ago, a lone little burro roamed the high cliffs of the Grand Canyon and touched the hearts of all who knew him: a grizzled old miner, a big-game hunter, even President Teddy Roosevelt. Named Brighty by the prospector who befriended him, he remained a free spirit at heart. But when a ruthless claim-jumper murdered the prospector, loyal Brighty risked everything to bring the killer to justice."), _c('br'), _c('br'), _vm._v("Brighty’s adventures have delighted generations of readers, and he has become the symbol of a joyous way of life. Some people say that you can even see his spirit roving the canyon on moonlit nights—forever wild, forever free.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Aladdin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0